<template>
<div class="popup" v-cloak v-show="noticeShow">
    <div class="content" id="transferNotice">
        <div class="title">
            <span>{{$t('language.popup.cancel')}}</span>
            <div class="icon white-close dialog-close" @click="noticeShow=false"></div>
        </div>
        <div class="notice-all-content">
            <span>{{$t('language.cloudTransfer.sureContinue')}}</span>
        </div>
        <div class="notice-all-footer">
            <div style="width: 100%;height:40Px; vertical-align: middle;">
                <button ref='b1' style="margin-right:50Px;border-radius:5Px;min-width: 107Px;" @click="transferData()">{{$t('language.cloudTransfer.sure')}}</button>
                <button ref='b2' class="cancel-button-two" @click="closeNotice()">{{$t('language.common.cancel')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
export default {
    data: function () {
        return {
            noticeShow: false,
            transferFlag: 0, //0表示立即传输 1仅仅添加任务 2添加任务并传输 3 taks_list界面更改options设置
            addData: null,
            transferFrom: 0, //0表示传输，1表示邮件传输
        }
    },
    mounted() {
        let width = this.$refs.b1.clientWidth;
        this.$refs.b2.style.width = width;
    },
    methods: {
        transferData() {
            this.noticeShow = false;
            if (this.transferFlag == 0) {
                this.$parent.transferNowRequest(this.addData);
            }
            if (this.transferFlag == 1) {
                this.$parent.doAddTasksRequest(this.addData);
            }
            if (this.transferFlag == 2) {
                this.$parent.addTaskAndTransferNowRequest(this.addData);
            }
            if (this.transferFlag == 3) {
                if(this.transferFrom == 0){
                    this.$parent.$refs.transferOptionsDialog.optionSubmitDetail();
                    this.$parent.$refs.transferOptionsDialog.optionDialogShow = false;
                }else{
                    this.$parent.$refs.emailTransferOptionsDialog.optionSubmitDetail();
                    this.$parent.$refs.emailTransferOptionsDialog.optionDialogShow = false;
                }
            }
        },
        closeNotice() {
            this.noticeShow = false;
            if (this.transferFlag == 3) {
                if(this.transferFrom == 0){
                    this.$parent.$refs.transferOptionsDialog.optionDialogShow = false;
                }else{
                    this.$parent.$refs.emailTransferOptionsDialog.optionDialogShow = false;
                }
            }
        }
    }
}
</script>

<style>
#transferNotice {
    width: 560px;
    /*no*/
    height: 210px;
    /*no*/
}

.notice-all-content {
    width: 100%;
    /*no*/
    height: 120px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    padding: 20px 20px 0 20px;
    /*no*/
}

.notice-all-footer {
    width: 100%;
    height: 48px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
    text-align: center;
}

.cancel-button-two,
.cancel-button-two:hover {
    border-radius: 5Px;
    background: #fff;
    color: #5562b4;
    border: 1Px solid #5562b4;
    min-width: 107Px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/transfer_notice_popup.vue